<template>
    <div class="card-error-state-challenge-select-user">
        <span class="card-error-state-challenge-select-user__art"></span>
        <h2 class="card-error-state-challenge-select-user__heading">Geçersiz Karakter</h2>
        <p class="card-error-state-challenge-select-user__desc">Kullanıcı adları yalnızca harf ve sayı içerebilir.</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/card-error-state-challenge-select-user.css"></style>